import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { pessoaService } from "@/services/api/PessoaService";
import { PessoaAcessoFiltrosCriteria } from "@/types/pessoa-acesso.type";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;

export const pessoaAcessoKeys = {
  list: ["pessoa-acessos-listagem"] as const,
  filtros: ["pessoa-acessos-filtros"] as const,
};

export const pessoaAcessoQueries = {
  list: (criteria: PessoaAcessoFiltrosCriteria) =>
    queryOptions({
      queryKey: [...pessoaAcessoKeys.list, criteria],
      queryFn: () => pessoaService.listAcessos(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: pessoaAcessoKeys.filtros,
      queryFn: () => pessoaService.getAcessosFiltros(),
      staleTime: FILTROS_STALE,
    }),
};
